import Button from "../components/Button";
import { isBetween } from "../utils";
import scoreIntervals from "../data/scoreIntervals";
import CountUp from "react-countup";

function GameEndPage({
  score,
  onPlayAgain,
  setInGame,
  difficulty,
  category,
  timeLimit,
}) {
  const scoreInterval = scoreIntervals.find((interval) =>
    isBetween(score[category.label], interval.min, interval.max)
  );
  return (
    <section
      className="flex flex-col items-center justify-center h-screen p-6 text-center "
      style={{
        background: `linear-gradient(
          rgba(0, 0, 0, 0.7), 
          rgba(0, 0, 0, 0.7)
        ), url(${scoreInterval.background}) no-repeat center/cover`,
      }}
    >
      <div className="mb-10 text-3xl">
        You got a score of{" "}
        <span className="font-mono text-blue-400 text-7xl">
          <CountUp
            start={0}
            end={score[category.label]}
            duration={1.5}
            separator=","
          />
        </span>{" "}
        for <em>{category.label}</em> on{" "}
        <span className="font-serif text-5xl">{difficulty.label} Mode</span>{" "}
        {timeLimit.value !== null
          ? `with ${timeLimit.label} to make your judgements`
          : ""}
        .
      </div>

      <div className="flex flex-col justify-center md:flex-row">
        <Button
          onClick={() => setInGame(false)}
          className="bg-transparent border-2 border-white hover:bg-white hover:text-black"
          text="Back to Menu"
        />
        <Button
          onClick={onPlayAgain}
          className="bg-transparent border-2 border-white hover:bg-white hover:text-black"
          text="Play Again"
        />
      </div>
    </section>
  );
}

export default GameEndPage;
